import type { Job } from "@freeconvert/freeconvert-node/dist/types";
import { CompressImage } from "store/features/compress/types";
import { get } from "../Backend/get";
import { JobSocket } from "../Job/JobSocket";

export interface CompressServiceOptions {
    handleDisconnect: () => void;
    handleReconnect: () => void;
    handleJobComplete: (image: CompressImage, job: Job) => void;
    handleJobFail: (image: CompressImage, job: Job) => void;
    onOfflineLimitReach: (image: CompressImage, job: Job) => void;
}

export class CompressService {
    private image: CompressImage;
    private job: Job;
    private options: CompressServiceOptions;
    private isComplete = false;

    constructor(image: CompressImage, job: Job, options: CompressServiceOptions) {
        this.image = image;
        this.job = job;
        this.options = options;
    }

    public async startJob() {
        await this.initSocket();
    }

    private async initSocket() {
        new JobSocket(this.job, {
            handleDisconnect: this.handleDisconnect,
            handleReconnect: this.handleReconnect,
            handleJobComplete: this.handleJobComplete,
            handleJobFail: this.handleJobFail,
            onOfflineLimitReach: this.onOfflineLimitReach,
        });
        await this.checkStatus();
    }

    private handleDisconnect = () => {
        this.options.handleDisconnect();
    };

    private handleReconnect = () => {
        this.options.handleReconnect();
    };

    private handleJobComplete = async (job: Job) => {
        if (this.isComplete) return;

        // this.options.handleJobComplete(this.image, job);
        await this.checkStatus();
        this.isComplete = true;
    };

    private handleJobFail = (job: Job) => {
        this.options.handleJobFail(this.image, job);
    };

    private onOfflineLimitReach = (job: Job) => {
        this.options.onOfflineLimitReach(this.image, job);
    };

    private async checkStatus() {
        if (this.isComplete) return;
        const job = await get<Job>(`${process.env.NEXT_PUBLIC_BE_URL}/jobs/${this.job.id}`);

        if (job.error) return;

        if (job.result?.status === "completed") {
            this.options.handleJobComplete(this.image, job.result);
        }

        if (job.result?.status === "failed") {
            this.options.handleJobFail(this.image, job.result);
        }
    }
}
